module.exports = "    <div id=\"footer\">\r\n        <div class=\"footer-text\">\r\n            <div *ngIf=\"showDonation\" style=\"text-align:center\"> Donated by iGroup</div>\r\n            <span>Copyright &copy; 2025 iGroup (Asia Pacific) Ltd. </span>\r\n            <span>All Rights Reserved.</span>\r\n        </div>\r\n    </div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/html/pageFooter.html
// module id = 684
// module chunks = 1